export default __webpack_public_path__ + "static/media/notting_3.a3cbb6f5.jpg";